
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { EditEventForm } from '@/services/Calendar/Events/forms/EditEventForm';
import { EventsInterface, EventType } from '@/services/Calendar/Events/Interfaces';
import EventsRepository from '@/services/Calendar/Events';

@Component({
  inject: [
    'eventsRepository',
  ],
})
export default class EditRecurringEvent extends Vue {
  private readonly eventsRepository!: EventsRepository;

  private loading: boolean = true;
  private dateMenu: boolean = false;

  private events: EventsInterface;
  private form: WPXFormValue<EditEventForm> = new WPXFormValue(EditEventForm);
  private dayType: Array<{ value: number, text: string }> = [{
    value: 0,
    text: 'National Event',
  }, {
    value: 1,
    text: 'Custom Event',
  }];

  private async created(): Promise<void> {
    if (!this.$route.params.eventId) {
      await this.$router.push({ name: 'calendar_manage_events' });
      this.$notifications.error('Event ID not provided.');

      return;
    }

    try {
      this.events = await this.eventsRepository.getEvent(Number(this.$route.params.eventId));
      this.form.data.type = this.events.type;
      this.form.data.name = this.events.name;
      this.form.data.description = this.events.description;

      if (this.events.location) {
        this.form.data.location = this.events.location;
      }

      if (this.events.author) {
        this.form.data.author = this.events.author;
      }

      if (this.events.date) {
        this.form.data.date = new Date(this.events.date).toISOString().substr(0, 10);
      }
    } catch (e) {
      console.error(e);
    }

    this.loading = false;
  }

  private async edit(): Promise<void> {
    try {
      await this.eventsRepository.updateEvent({
        id: Number(this.$route.params.eventId),
        type: Number(this.form.data.type),
        name: this.form.data.name,
        description: this.form.data.description,
        location: this.form.data.location,
        author: this.form.data.author,
        date: new Date(this.form.data.date),
      });

      this.$successDialog.show('The event has been edited.');
    } catch (err) {
      this.$errorDialog.show(err.response.data.error);
    }
  }
}
